import { render, staticRenderFns } from "./AddBlog.vue?vue&type=template&id=5ec88ea0&scoped=true"
import script from "./AddBlog.vue?vue&type=script&lang=js"
export * from "./AddBlog.vue?vue&type=script&lang=js"
import style0 from "./AddBlog.vue?vue&type=style&index=0&id=5ec88ea0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ec88ea0",
  null
  
)

export default component.exports